import { z } from 'zod';

// 1-to-1 mapping with database columns
const rawOrganizationSchema = z.object({
  id: z.string(),
  name: z.string(),
  highbondId: z.string(),
});

// Minimal organization schema intended to be used for validating joined entities
export const minimalOrganizationSchema = rawOrganizationSchema.pick({
  id: true,
});
export type MinimalOrganizationEntity = z.infer<
  typeof minimalOrganizationSchema
>;
